import './App.css';
import './Pages/css/main.css';
import { Routes, Route, Navigate, Outlet, useParams } from 'react-router-dom';
import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';

import UrlCreate from './Pages/urlCreate';
import UrlPayment from './Pages/urlPayment';
import UrlComplete from './Pages/urlComplete';
import UrlDetail from './Pages/urlDetail';
import UrlUserHistory from './Pages/urlUserHistory';
import UrlNotice from './Pages/urlNotice';

import ErrorBoundary from './Pages/common/ErrorBoundary';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { change_hostLogoImg, checkLogin } from './store';

import ScrollToTop from './ScrollToTop';

/** /:mid 라우트 가드: 훅을 항상 먼저 호출하고, JSX에서 조건부 렌더링 */
function MidLayout() {
    const { mid: rawMid } = useParams();
    const dispatch = useDispatch();

    const mid = rawMid ? decodeURIComponent(rawMid) : '';
    const isValid = /^[A-Za-z0-9._-]+$/.test(mid);

    // 훅은 항상 호출하고, 내부에서 조건 분기
    useEffect(() => {
        if (isValid) {
            dispatch(checkLogin(mid));
        }
    }, [dispatch, mid, isValid]);

    // JSX에서 조건부 렌더 → 훅은 이미 호출된 상태라 ESLint 경고 없음
    return isValid ? <Outlet /> : <Navigate to="/urlNotice" replace />;
}

function App() {
    console.error = () => { }; // 기존 동작 유지

    const dispatch = useDispatch();

    useEffect(() => {
        if (window.location.hostname === 'cp.onu-terminal.com') {
            dispatch(change_hostLogoImg('onu'));
        } else {
            dispatch(change_hostLogoImg('fast'));
        }
    }, [dispatch]);

    return (
        <div className="App" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <ScrollToTop behavior="auto" />
            <div className="py-0 md:py-5 header">
                <Header />
                <div style={{ width: '100%' }}>
                    <ErrorBoundary>
                        <Routes>
                            {/* 안내 페이지 */}
                            <Route path="/urlNotice" element={<UrlNotice />} />
                            <Route path="/" element={<Navigate to="/urlNotice" replace />} />

                            {/* /:mid 가드 레이아웃으로 감싸기 */}
                            <Route element={<MidLayout />}>
                                <Route path="/:mid" element={<UrlCreate />} />
                                <Route path="/:mid/detail" element={<UrlDetail />} />
                                <Route path="/:mid/payment" element={<UrlPayment />} />
                                <Route path="/:mid/complete" element={<UrlComplete />} />
                                <Route path="/:mid/history" element={<UrlUserHistory />} />
                            </Route>

                            {/* 나머지는 안내로 */}
                            <Route path="*" element={<Navigate to="/urlNotice" replace />} />
                        </Routes>
                    </ErrorBoundary>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default App;
